// src/components/SocialLinks/SocialLinks.js
import React from 'react';
import { FaFacebook, FaInstagram, FaTiktok, FaLinkedin, FaWhatsapp } from 'react-icons/fa'; // Import React Icons
import './SocialLinks.css'; // Optional: Add styles for the social links

const socialLinks = [
  { icon: <FaFacebook />, url: 'https://www.facebook.com/profile.php?id=61574797683652'},
  { icon: <FaTiktok />, url: 'https://tiktok.com/@kozeesg'},
  { icon: <FaInstagram />, url: 'https://instagram.com/KozeeSG'},
  { icon: <FaLinkedin/>, url:"https://linkedin.com"},
  { icon: <FaWhatsapp />, url: 'https://wa.me/6596366354'},

];

const SocialLinks = () => {
  return (
    <div className="social-links-section">
      <h2 className="social-links-heading">Find Us At: </h2>
      <div className="social-links-grid">
        {socialLinks.map((link, index) => (
          <a
            key={index}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            className="social-link-item"
          >
            <div className="social-icon">{link.icon}</div>
            <p className="social-link-text">{link.text}</p>
          </a>
        ))}
      </div>
    </div>
  );
};

export default SocialLinks;